/* eslint-disable import/no-anonymous-default-export */
import { getTimeZone } from "utils";
import { api, asResult, downloadCsv } from "utils/apiClient";
import { GroupType } from "utils/constants";
import { normalizeGroup } from "utils/normalize";

const CSV_FILENAME = {
  [GroupType.ServiceProvider]: "service_providers.csv",
  [GroupType.Tenant]: "tenants.csv",
  [GroupType.Location]: "locations.csv",
};

export default {
  // Every tenant the caller may see; tenant and location users get their own.
  async listTenants() {
    const { items } = await api("GET", "/groups", {
      query: { type: GroupType.Tenant },
    });
    return { items: items.map(normalizeGroup) };
  },

  // The tenant's SP is the only upper level sent; the BE reads parentID from it.
  async createTenant({ tenantId, tenant, mfa, spID }) {
    const result = await asResult(
      api("POST", "/groups", {
        body: {
          type: GroupType.Tenant,
          groupName: tenantId,
          descName: tenant,
          spID,
          mfa,
        },
      })
    );
    // the generated ID is taken: the caller retries with another one
    return { ...result, groupExists: result.code === "GROUP_EXISTS" };
  },

  async editTenant({ tenantId, tenantName, mfa }) {
    return asResult(
      api("PATCH", `/groups/${encodeURIComponent(tenantId)}`, {
        body: { descName: tenantName, mfa },
      })
    );
  },

  // Any group type: SP, tenant or location.
  async removeGroup(group) {
    if (!group) return;
    return asResult(api("DELETE", `/groups/${encodeURIComponent(group)}`));
  },

  // CSV of every group of `type` the caller may see.
  async exportGroup(type) {
    const csv = await api("GET", "/groups/export", {
      query: { type, timezone: getTimeZone() },
      text: true,
    });
    downloadCsv(csv, CSV_FILENAME[type] ?? "tenants.csv");
  },
};
